import React, { useState } from "react";
import "./FAQ.css";
import "../../index.css";
import "../../reusable/components/text/Text.css";
import { DropdownIcon, DropupIcon } from "./FaqIcons";


const faqs = [
  {
    q: "What is Kydoscope?",
    a: "Kydoscope is a dedicated platform for interior designers and architects to showcase portfolios, connect with potential clients, collaborate with peers, and stay updated on design trends - all in one place.",
  },
   {
   q: "How do I get started?",
   a: "Just click “Create Profile,” follow the easy setup steps, upload your work, and you’re live! No technical skills or web design required.",
  },
  {
    q: "Is Kydoscope free to use?",
    a: "Yes, creating a profile and showcasing your portfolio is free. Upgrade to the Premium Profile to unlock more features.",
  },
{
    q: "Do I need a website to use Kydoscope?",
    a: "Nope! You can create a full-featured professional profile on Kydoscope without needing your own website.",
  },
{
    q: "Is Kydoscope only for established designers?",
    a: "Not at all. Whether you’re just starting out or have years of experience, Kydoscope is built to support all stages of your design journey.",
  },
  {
    q: "Who can see my profile?",
    a: "Your profile can be viewed by potential clients, design enthusiasts, collaborators, and other professionals looking to hire or partner with designers.",
  },
  {
    q: "Can I use Kydoscope to find jobs or projects?",
    a: "Yes! Kydoscope connects you with people actively looking to hire interior designers and architects.",
  },
  {
    q: "Can I hire other designers or team members on Kydoscope?",
    a: "Absolutely. If you're building a team, you can discover and connect with other verified professionals on the platform.",
  },
  {
    q: "What can I include in my profile?",
    a: "Your profile can feature portfolio images, project descriptions, services, credentials, location, and contact info - everything you need to present your design identity.",
  },
  {
    q: "How do I stay updated on trends and industry news?",
    a: "Kydoscope curates trend updates, design highlights, and peer showcases so you’re always in the loop. Go to our Resource Centre to explore more.",
  },
  {
    q: "Is my data safe?",
    a: "We take privacy and security seriously. Check our Terms of use and privacy policies to know more.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className="faq-page">
      <h1 className="faq-title heading-quaternary-font">
        FAQs
      </h1>

      <div className="faq-list">
        {faqs.map((item, idx) => (
          <div className={`faq-item${open === idx ? " open" : ""}`} key={idx}>
            <button
              type="button"
              className="document-content"
              style={{
                width: '100%',
                background: 'none',
                border: 'none',
                textAlign: 'left',
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '20px 24px',
                margin: '0',
                color: '#1F2937',
                fontWeight: '500',
              }}
              onClick={() => setOpen(open === idx ? null : idx)}
              aria-expanded={open === idx ? "true" : "false"}
              aria-controls={`faq-answer-${idx}`}
            >
              {item.q}
              <span className="faq-caret">{open === idx ? <DropupIcon /> : <DropdownIcon />}</span>
            </button>
            <div
              className="document-content"
              id={`faq-answer-${idx}`}
              style={{ display: open === idx ? "block" : "none", padding: '0 24px 20px 24px' }}
            >
              {item.a}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
